import { render, staticRenderFns } from "./EditLiveReviewConsumptionHistoryTable.vue?vue&type=template&id=0a4e49b8&scoped=true"
import script from "./EditLiveReviewConsumptionHistoryTable.vue?vue&type=script&lang=js"
export * from "./EditLiveReviewConsumptionHistoryTable.vue?vue&type=script&lang=js"
import style0 from "./EditLiveReviewConsumptionHistoryTable.vue?vue&type=style&index=0&id=0a4e49b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4e49b8",
  null
  
)

export default component.exports